import { useEffect, useRef } from 'react';
import blockies from 'ethereum-blockies-base64';

interface BlockiesAvatarProps {
  seed: string;
  size?: number;
  scale?: number;
  className?: string;
}

export const BlockiesAvatar = ({ 
  seed, 
  size = 10, 
  scale = 4,
  className = ''
}: BlockiesAvatarProps) => {
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (imgRef.current && seed) {
      const icon = blockies(seed.toLowerCase());
      
      imgRef.current.src = icon;
    }
  }, [seed, size, scale]);

  return (
    <img 
      ref={imgRef}
      alt={`Avatar for ${seed}`}
      className={`rounded-full ${className}`}
      style={{ 
        width: size * scale, 
        height: size * scale,
        imageRendering: 'pixelated'
      }}
    />
  );
};